const discountTypes = {
  PERCENTAGE: "PERCENTAGE",
  PRICE: "PRICE"
};

export default discountTypes;
